import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ToastService } from 'angular-toastify';
import { NgxSpinnerService } from 'ngx-spinner';
import { switchMap } from 'rxjs/operators';
import { JIRA_BOARD_PROJECT_IDS, JIRA_BOARD_PROJECT_Name } from 'src/app/constant/constant';
import { RepositoryService } from 'src/app/service/repository.service';
interface JiraResponse {
  key: { key: string };
  jiraToken: string;
}
@Component({
  selector: 'app-compartmentdelete',
  templateUrl: './compartmentdelete.component.html',
  styleUrls: ['./compartmentdelete.component.css']
})
export class CompartmentdeleteComponent implements OnInit {
  @ViewChild('fileUpload') fileInput: ElementRef;
  cloudForm: FormGroup;
  compartmentNames: Array<any> = [];
  filteredComponentName: Array<any> = [];
  filepath: File;
  projectName: string = JIRA_BOARD_PROJECT_Name.OCI;
  projectID: string = JIRA_BOARD_PROJECT_IDS.OCI;
  summary: string;
  @Input() tabGroup!: MatTabGroup;
  constructor(private fb: FormBuilder, private rs: RepositoryService, private _toastService: ToastService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.cloudForm = this.fb.group({
      compartmentName: ['', [Validators.required]],
    });
    this.loadOCICompartmentNames();
  }
  /**Loads OCI Compartments */
  private loadOCICompartmentNames(): void {
    this.spinner.show()
    this.rs.getOCIAccounts("All", "List").subscribe({
      next: (res) => {
        this.compartmentNames = res['Items'];
        this.filteredComponentName = [...this.compartmentNames];
        this.spinner.hide();
      },
      error: (error) => {
        this._toastService.error(error?.message);
        this.spinner.hide();
      }
    })


  }
  handleFilteredcomponentReturn(filteredData: any[]): void {
    this.filteredComponentName = filteredData
  }
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files[0]) {
      this.filepath = input.files[0]

    }
  }
  resetform(): void {

    this.cloudForm.reset();
    this.filepath = null;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = ''; // Clear the file path
    }

  }

  onSubmit(): void {
    this.spinner.show();
    this.summary = `Delete component from ${this.cloudForm.get('compartmentName').value}`;

    this.rs.createCloudServiceRequest(this.projectName, this.summary, this.cloudForm.value, sessionStorage.getItem("wwid"))
      .pipe(switchMap((jiraRes: JiraResponse) =>
        this.rs.jiraAttachment(this.filepath, jiraRes?.key?.key, this.projectID, jiraRes['jiraToken'])
      )).subscribe({
        next: (res) => {
          this._toastService.success(res['message']);
          this.resetform();
          if (this.tabGroup) {
            this.tabGroup.selectedIndex = 1; // Move to the next tab
          };
          this.spinner.hide();
        },
        error: (error) => {
          this.spinner.hide();
          this._toastService.error(error?.message || "An unexpected error occurred.");
        }
      });
  }


}
